import {getPublicationContentList, getPublicationArticlesList,getAuthorArticlesList, getPublisherArticlesList, getCollectionDetail, getDossierDetail} from '@/libs/api/api'
import {loader, message, logout, errorHandler} from '@/libs/helper'
import {cloneDeep, groupBy, map, isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'
import DetailMenu from '@/components/pages/InformationPortal/ProfilePage/DetailMenu/DetailMenu.vue'
export default {
    name: 'ArticlesPage',
    components: {
        DetailMenu,
        'ArticleCard': () => import('@/components/pages/InformationPortal/ProfilePage/ArticleCard/ArticleCard.vue')
    },
    props: {
        updateArticleCount: {
            type: Function,
            default: () => {}
        },
        updateCount: {
            type: Function,
            default: () => {}
        },
        getCollectionCount: {
            type: Function,
            default: () => {}
        },
        activateSharePopup: {
            type: Function,
            default: () => {}
        },
        changeUpdateArticleShareCount: {
            type: Function, 
            default: () => {}
        },
        updateArticleShareCount: {
            type: Object,
            default: () => {}
        },
        // left menu
        module: {
            type: String,
            default: ''
        },
        details: {
            type: Object,
            default: () => {}
        },
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        followUnfollowAction: {
            type: Function,
            default: () => {}
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        followCollection: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        setFavourite: {
            type: Function,
            default: () => {}
        },
        articlesCount: {
            type: Number,
            default: 0
        },
        collectionCount: {
            type: Number,
            default: 0
        },
        followersCount: {
            type: Number,
            default: 0
        },
        collectionFollowersCount: {
            type: Number,
            default: 0
        },
        dossierCount: {
            type: Number,
            default: 0
        },
        collectionArticleCount: {
            type: Number,
            default: 0
        },
        routeToCollectionPage: {
            type: Function,
            default: () => {}
        },
        setCollectionFavorite: {
            type: Function,
            default: () => {}
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        routeToAboutPage: {
            type: Function,
            default: () => {}
        },
        fetchMetaDetails: {
            type: Function,
            default: () => {}
        }
    },
    beforeMount() {
        if (this.$route.name === 'publication-collections-page' || this.$route.name === 'author-collections-page' || this.$route.name === 'publisher-collections-page') {
            this.isCollection = true
        }
        if (this.$route.name === 'publication-dossiers-page' || this.$route.name === 'publisher-dossiers-page' || this.$route.name === 'author-dossiers-page') {
            this.isDossier = true
        }
        if (!this.isCollection && !this.isDossier) {
          this.getNavBar()
        }
    },
    watch: {
        updateArticleShareCount (value) {
            if (!isEmpty(value)) this.updateArticleSharingCount(value)
        }
    },
    mounted() {
        if (this.isCollection || this.isDossier) this.getCollectionArticles()
        else this.fetchLatestArticles()
    },
    data() {
        return {
            extendedView: false,
            isCollection: false,
            articles: [],
            articlesToDisplay: [],
            articlesResult: {},
            sortAs: 'Most recent',
            searchValue: '',
            subMenuList: [],
            activeLabel: 'latest',
            activeMenu: {},
            skip: 0,
            limit: 30,
            sorting: 'pub_date',
            collectionSorting: 'createdAt',
            order: 'desc',
            currentPage: 1,
            isDossier: false,
            showIcons: false,
            articleToBeAddedinDocuments: '',
            articleToBeShared: ''
        }
    },
    methods: {
        /**
         * sort method to the articles listing
         * @param {*} command 
         */
        sort () {
        },

        /**
         * to change the sorting order
         */
        changeSortingOrder (command) {
            this.skip = 0
            this.currentPage = 1
            this.sorting = command
            if (this.isCollection || this.isDossier) this.getCollectionArticles()
            else this.fetchLatestArticles()
        },
        /**
         *  to get the search bar for the page
         */
        getNavBar () {
            // body
            let body = {
                publication_id: this.$route.params.id
            }
            // api call
            getPublicationContentList(body).then(response => {
                let menu = response.result || []
                // to group on the name
                menu = groupBy(menu, 'name')
                // map to get the result in the clubbing ids of similiar types
                menu = map(menu, (list) => {
                    list['entity_ids'] = map(list, '_id')
                    return {
                        name: list[0].name,
                        full_url: list[0].full_url,
                        _id: list[0]._id,
                        url: list[0].url,
                        path: list[0].path,
                        order: list[0].order,
                        entity_ids: map(list, '_id')
                    }
                })
                // the list to be shown on UI
                this.subMenuList = cloneDeep(menu)
            }).catch(() => {
            })
        },
        /**
         * fetch the latest articles
         * @param {*} isLoader 
         */
        fetchLatestArticles (isLoader) {
            // set active menu and label
            this.activeMenu = {}
            this.activeLabel = 'latest'
            this.skip = 0
            // params for api
            let params = {
                skip: this.skip,
                limit: this.limit,
                sort: this.sorting,
                order: this.order
            }
            // body for api
            let body = {}
            
            // get the articles listing for latest tab
            this.fetchArticles(body, params, isLoader, true)
        },

        /**
         * api fetch the articles 
         * @param {*} body 
         * @param {*} params 
         * @param {*} isLoader 
         */
        fetchArticles (body, params, isLoader, isUpdateCount) {
            if (isLoader) loader(this, true)
            // setiing body on conditions
            if (this.module === constants.AUTHOR.key) {
                body.author_id = this.$route.params.id
                // api call
                getAuthorArticlesList(params, body).then(response => {
                this.articles = response.items || []
                // set the articles to display
                this.articlesToDisplay = cloneDeep(response.items || [])
                this.articlesResult = cloneDeep(response)
                if (isUpdateCount) this.updateArticleCount(response.total_count)
                if (isLoader) loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                if (isLoader) loader(this, false)
            })
            }
            else if (this.module === constants.PUBLISHER.key) {
                body.publisher_id = this.$route.params.id
                // api call
                getPublisherArticlesList(params, body).then(response => {
                    this.articles = response.items || []
                    // set the articles to display
                    this.articlesToDisplay = cloneDeep(response.items || [])
                    this.articlesResult = cloneDeep(response)
                    if (isUpdateCount) this.updateArticleCount(response.total_count)
                    if (isLoader) loader(this, false)
                }).catch((error) => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    if (isLoader) loader(this, false)
                })
            }
            else if (this.module === constants.PUBLICATION.key) {
                body.publication_id = this.$route.params.id
                // api call
                getPublicationArticlesList(params, body).then(response => {
                    this.articles = response.items || []
                    // set the articles to display
                    this.articlesToDisplay = cloneDeep(response.items || [])
                    this.articlesResult = cloneDeep(response)
                    if (isUpdateCount) this.updateArticleCount(response.total_count)
                    if (isLoader) loader(this, false)
                }).catch((error) => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    if (isLoader) loader(this, false)
                })
            }
        },
        /**
         * changeMenu item for the articles
         * @param {*} menu 
         */
        changeMenu (menu) {
            this.activeMenu = menu
            this.activeLabel = menu.name
            this.skip = 0
            this.currentPage = 1
            this.getArticles()
        },
        /**
         * setting the body for fetching articles
         */
        getArticles () {
            // params for api
            let params = {
                skip: this.skip,
                limit: this.limit,
                sort: this.sorting,
                order: this.order
            }
            // body for api
            let body = {
                content_ids: this.activeMenu.entity_ids
            }
            this.fetchArticles(body, params, true)
        },
        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // if collection is true
            if (this.isCollection) {
                // call for fetching the collection articles
                this.getCollectionArticles()
            } 
            else {
                // call for fetching the articles
                this.getArticles()
            }
        },

        /**
         * create the body and params for collection articles
         */
        getCollectionArticles () {
            // params for api
            let params = {
                skip: this.skip,
                limit: this.limit,
                sort: this.sorting,
                order: this.order
            }
            if (this.isDossier) this.fetchDossierArticles(params)
            else this.fetchCollectionArticles(params)
        },

        /**
         * api call for fetching collection articles
         */
        fetchCollectionArticles (params) {
            loader(this, true)
            // body for api
            let body = {
                collection_id: this.$route.params.cid,
                entity_id: this.$route.params.id,
                entity_type: this.module
            }
            // api call
            getCollectionDetail(body, params).then(response => {
                // to update the count
                this.updateCount(constants.LIST.COLLECTION_ARTICLES, (response.total_count || 0))
                this.articles = response.items || []
                // set the articles to display
                this.articlesToDisplay = cloneDeep(response.items || [])
                // seeting the seult to make the pagination
                this.articlesResult = cloneDeep(response)
                loader(this, false)
            }).catch((error) => {
                if (error.code === 'INVALID_ACCESS') {
                    this.$router.push({name: `${this.module.toLowerCase()}-collections`}).catch(() => {})
                    this.getCollectionCount()
                }
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * api call for fetching dossier articles
         */
        fetchDossierArticles (params) {
            loader(this, true)
            // body for api
            let body = {
                dossier_id: this.$route.params.did,
                entity_id: this.$route.params.id,
                entity_type: this.module
            }
            // api call
            getDossierDetail(body, params).then(response => {
                // to update the count
                this.updateCount(constants.LIST.COLLECTION_ARTICLES, (response.total_count || 0))
                this.articles = response.items || []
                // set the articles to display
                this.articlesToDisplay = cloneDeep(response.items || [])
                // seeting the seult to make the pagination
                this.articlesResult = cloneDeep(response)
                loader(this, false)
            }).catch(error => {
                if (error.code === 'INVALID_ACCESS') {
                    this.$router.push({name: `${this.module.toLowerCase()}-dossiers`}).catch(() => {})
                    this.getCollectionCount(true)
                }
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },

        /**
         * update the article results
         * @param {*} articleToUpdate 
         */
        updateArticleFavorite (articleToUpdate) {
            let articlesToDisplay = cloneDeep(this.articlesToDisplay)
            this.articlesToDisplay = articlesToDisplay.map(article => {
                if (article._id === articleToUpdate._id) article.favorites = articleToUpdate.favorites || []
                return article
            })
        },

        /**
         * to show the add documents section
         * @param {*} id 
         */
        showAddToDocuments (id) {
            this.articleToBeAddedinDocuments = id ? id : ''
        },
        /**
         * to open up the share article flow
         * @param {*} id 
         */
        changeShareArticle (id) {
            this.articleToBeShared = this.articleToBeShared === id ? '' : id
        },
        /**
         * to update when clicked on add to Documents 
         * @param {*} articleToUpdate 
         */
        updateArticleCatalog (articleToUpdate) {
            let articlesToDisplay = cloneDeep(this.articlesToDisplay)
            this.articlesToDisplay = articlesToDisplay.map(article => {
                if (article._id === articleToUpdate._id) article.added_via_extension = articleToUpdate.added_via_extension
                return article
            })
        },
        /**
         * update article share count
         * @param {*} articleToUpdate 
         */
        updateArticleSharingCount (articleToUpdate) {
            let articlesToDisplay = cloneDeep(this.articlesToDisplay)
            this.articlesToDisplay = articlesToDisplay.map(article => {
                if (article._id === articleToUpdate._id) article.sharing_count = (articleToUpdate.sharing_count || 0) + 1
                return article
            })
            this.changeUpdateArticleShareCount({})
            this.changeShareArticle('')
        }
    }
}